import { bellContainer } from './NotificationBell.css';

export interface NotificationBellProps {
  /**
   * Number of unread notifications
   */
  count?: number;

  /**
   * Callback when the bell is clicked
   */
  onClick?: () => void;

  /**
   * Additional CSS class name
   */
  className?: string;
}

/**
 * NotificationBell component that displays a bell icon with optional notification count
 */
export function NotificationBell({ count = 0, onClick, className }: NotificationBellProps) {
  return (
    <button aria-label="Notifications" className={`${bellContainer} ${className || ''}`} onClick={onClick}>
      {/* Bell icon (using SVG for better control) */}
      <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
          fill="currentColor"
        />
      </svg>

      {/* Notification count badge */}
      {count > 0 && <span className="badge">{count > 99 ? '99+' : count}</span>}
    </button>
  );
}
